/* frontend/src/components/CommentForm.js */
import React, { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postComment } from '../utils/api';
import axios from 'axios';
import '../pages/Blog.css';

const CommentForm = ({ articleId, refetchComments }) => {
  const [content, setContent] = useState('');
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  // Fetch CSRF token on mount
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/get-csrf-token/`, { withCredentials: true })
      .catch((err) => console.error('Failed to fetch CSRF token:', err));
  }, []);

  const mutation = useMutation({
    mutationFn: (content) => postComment(articleId, content),
    onSuccess: () => {
      setContent('');
      setError(null);
      refetchComments();
    },
    onError: (error) => {
      console.error('Comment submission error:', error);
      let errorMessage = 'Failed to post comment. Please try again.';
      if (error.response?.status === 405) {
        errorMessage = 'Invalid request method. Contact support.';
      } else if (error.response?.status === 403) {
        errorMessage = 'Permission denied. Please log in.';
      } else if (error.response?.data?.errors) {
        errorMessage = JSON.stringify(error.response.data.errors);
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      }
      setError(errorMessage);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim()) {
      mutation.mutate(content);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      {error && (
        <div className="bg-red-100 text-red-700 p-4 rounded mb-4">{error}</div>
      )}
      <textarea
        className="w-full p-2 border rounded text-[#333333] !text-[#333333] bg-white !bg-white focus:outline-none focus:ring-2 focus:ring-[#0a66c2]"
        rows="4"
        placeholder="Add a comment..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      <button type="submit" className="btn-primary mt-2">
        Post Comment
      </button>
    </form>
  );
};

export default CommentForm;
